<!--
	账单统计列表
	lovi 2020-03-04
-->
<template>
  <div class="subOrder-wrap">
    <search
      v-if="data.status == 0"
      :statusFlag="true"
      :statusList="selectList"
      :printFlag="true"
      @search="getSearch"
      @getExcel="getExcel"
    />
    <div
      class="toExcel"
      v-if="
        listData.length &&
          ((openFilter && curStatus == 1) || (!openFilter && curStatus == 2))
      "
    >
      <export-excel
        fileName="failed"
        :tHeader="exportHeader"
        :filterVal="exportFilterVal"
        :exportList="exportExcelData"
        :btnType="1"
        :btnText="$t('recharge.export') + 'Excel'"
      />
    </div>
    <div ref="printBox">
      <div class="list-wrap">
        <div class="no-data" v-if="!listData.length">
          <img
            :src="
              require('@/assets/images/public/no_data_' +
                (language == 'en' ? 'en' : 'cn') +
                '.png')
            "
          />
          <p>{{ $t("common.noData") }}</p>
        </div>
        <template v-else>
          <!-- 批量话费、批量流量 -->
          <template v-if="data.type == 20 || data.type == 21">
            <div
              class="item-list"
              v-for="(item, index) in listData"
              :key="index"
            >
              <div class="list-l">
                <h3>{{ item.phone }}</h3>
                <p class="text-gray">
                  {{ $t("common.transactionTime") }}：{{ item.createtime }}
                </p>
                <p class="text-gray">
                  {{ $t("common.orderNumber") }}：{{ item.order_sn }}
                  {{ $t("common.thirdPartyOrderNumber") }}：{{
                    item.third_order_no
                      ? item.third_order_no
                      : $t("common.nothing")
                  }}
                </p>
              </div>
              <div class="list-r">
                <h3>
                  {{
                    item.money_type == 1
                      ? "+"
                      : item.money_type == 2
                      ? "-"
                      : ""
                  }}{{ item.money }}
                </h3>
                <p :class="item.status_key == 1 ? 'text-red' : 'text-blue'">
                  {{ item.status }}
                </p>
              </div>
            </div>

            <div class="page-wrap">
              <div class="total">
                <template v-if="curStatus == 0">
                  <!-- <span>订单总数{{orderData.total_order_subs}}条</span> -->
                  <span>
                    {{ $t("common.succeed") }}：{{ orderData.success_nums
                    }}{{ $t("common.items") }}
                  </span>
                  <span class="text-red">
                    {{ $t("common.failed") }}：{{ orderData.fail_nums
                    }}{{ $t("common.items") }}
                  </span>
                  <span>
                    {{ $t("common.totalExpenditure") }}：{{ orderData.count }}P
                  </span>
                  <span class="text-blue">
                    {{ $t("common.refundAmount") }}：{{
                      orderData.refund_amount
                    }}P
                  </span>
                </template>
                <template v-else>&nbsp;</template>
              </div>
              <Page
                :total="orderData.nums"
                @on-change="_getPage(page)"
                :current.sync="page"
                size="small"
                show-total
              />
            </div>
          </template>
          <!-- 批量转账 -->
          <template v-else>
            <div
              class="item-list"
              v-for="(item, index) in listData"
              :key="index"
            >
              <div class="list-l">
                <h3>{{ item.username }}</h3>
                <p class="text-gray">
                  {{ $t("common.mobileNumber") }}：{{ item.phone }}
                </p>
                <p class="text-gray">
                  {{ $t("common.transactionTime") }}：{{ item.createtime }}
                  {{ $t("common.orderNumber") }}：{{ item.order_sn }}
                </p>
              </div>
              <div class="list-r">
                <h3>
                  {{
                    item.money_type == 1
                      ? "+"
                      : item.money_type == 2
                      ? "-"
                      : ""
                  }}{{ item.money }}
                </h3>
                <p :class="item.status_key == 1 ? 'text-red' : 'text-blue'">
                  {{ item.status }}
                </p>
              </div>
            </div>

            <div class="page-wrap">
              <div class="total">
                <template v-if="curStatus == 0">
                  <span>
                    {{ $t("common.succeed") }}：{{ orderData.success_nums
                    }}{{ $t("common.items") }}
                  </span>
                  <span class="text-red">
                    {{ $t("common.failed") }}：{{ orderData.fail_nums
                    }}{{ $t("common.items") }}
                  </span>
                  <span>
                    {{ $t("common.totalExpenditure") }}：{{ orderData.count }}P
                  </span>
                  <span class="text-blue">
                    {{ $t("common.refundAmount") }}：{{
                      orderData.refund_amount
                    }}P
                  </span>
                </template>
                <template v-else>&nbsp;</template>
              </div>
              <Page
                :total="orderData.nums"
                @on-change="_getPage(page)"
                :current.sync="page"
                size="small"
                show-total
              />
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Search from "@/components/search";
import ExportExcel from "@/components/excel/export";
export default {
  props: ["data"],
  components: {
    Search,
    ExportExcel
  },
  data() {
    return {
      curStatus: 0,
      openFilter: 0,
      page: 1,
      row: 10,
      orderData: {},
      listData: [],
      // 筛选条件
      selectList: [
        { key: 0, name: this.$t("common.all") },
        { key: 1, name: this.$t("recharge.successfulTransaction") },
        { key: 2, name: this.$t("recharge.transactionFailed") }
      ],

      exportHeader: [],
      exportFilterVal: [],
      exportExcelData: []
    };
  },
  created() {
    let vm = this;
    vm.curStatus = vm.data.status;
    if (vm.data.status == 0 && (vm.data.type == 20 || vm.data.type == 21)) {
      vm.openFilter = 1;
      vm.getStatusList();
    } else {
      vm.getListData();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    getStatusList() {
      // 获取状态列表
      let vm = this;
      let params = {};
      params.type = vm.data.type == 20 ? 5 : 6;
      vm.$post("/app/help/statusList", params, { loading: true }).then(res => {
        console.log("statusList", res);
        vm.selectList = res;
        if (vm.openFilter) {
          vm.curStatus = vm.selectList[0].key;
        }
        vm.getListData();
      });
    },
    getSearch(data) {
      //搜索
      let vm = this;
      console.log(data, "data");
      vm.curStatus = data.statusVal;
      vm.page = 1;
      vm.getListData();
    },
    getExportExcelData() {
      //excel 数据
      let vm = this;
      let tHeader = [];
      let filterVal = [];
      let list = [];
      if (vm.data.type == 20 || vm.data.type == 21) {
        // 批量话费、批量流量
        tHeader = [this.$t("common.mobileNumber")];
        filterVal = ["phone"];
        for (let key of vm.listData) {
          let obj = {};
          obj.phone = key.phone;
          list.push(obj);
        }
      } else {
        // 批量转账
        tHeader = [
          this.$t("personal.eepayAccount"),
          this.$t("common.mobileNumber"),
          this.$t("transfer.transferAmount") + "(PHP)"
        ];
        filterVal = ["username", "phone", "money"];
        for (let i = 0; i < vm.listData.length; i++) {
          let obj = {};
          obj.username = vm.listData[i].username;
          obj.phone = vm.listData[i].phone;
          obj.money = Number(vm.listData[i].money.split("P")[0]);
          list.push(obj);
        }
      }
      vm.exportHeader = tHeader;
      vm.exportFilterVal = filterVal;
      vm.exportExcelData = list;
      console.log("exportExcelData", vm.exportExcelData);
    },
    getExcel() {
      // 打印
      let thisHtml = this.$refs.printBox.innerHTML;
      let newWin = window.open();

      newWin.document.body.innerHTML = thisHtml;
      let box = newWin.document.body.getElementsByClassName("list-wrap")[0];
      box.style.margin = "0 auto";
      box.style.width = "880px";
      box.style.border = "1px solid #c9c9c9";
      let item = box.getElementsByClassName("item-list");
      for (let i = 0; i < item.length; i++) {
        item[i].style.display = "flex";
        item[i].style.alignItems = "center";
        item[i].style.justifyContent = "space-between";
        item[i].style.padding = "15px 20px";
        item[i].style.borderBottom = "1px solid #c9c9c9";
        let itemH3 = item[i].getElementsByTagName("h3");
        for (var j = 0; j < itemH3.length; j++) {
          itemH3[j].style.margin = "0";
          itemH3[j].style.fontSize = "16px";
          itemH3[j].style.fontWeight = "500";
        }
        let itemP = item[i].getElementsByTagName("p");
        for (var k = 0; k < itemP.length; k++) {
          itemP[k].style.margin = "0";
          itemP[k].style.fontSize = "14px";
          if (itemP[k].className == "text-blue") {
            itemP[k].style.color = "#2042AB";
          }
          if (itemP[k].className == "text-red") {
            itemP[k].style.color = "#D0021B";
          }
          if (itemP[k].className == "text-gray") {
            itemP[k].style.color = "#999999";
          }
        }
      }
      let pageWrap = newWin.document.body.getElementsByClassName(
        "page-wrap"
      )[0];
      pageWrap.style.display = "flex";
      pageWrap.style.alignItems = "center";
      pageWrap.style.justifyContent = "space-between";
      pageWrap.style.padding = "15px 20px";
      pageWrap.style.fontSize = "14px";
      let spanItem = pageWrap
        .getElementsByClassName("total")[0]
        .getElementsByTagName("span");
      for (let i = 0; i < spanItem.length; i++) {
        spanItem[i].style.marginRight = "10px";
        if (spanItem[i].className == "text-blue") {
          spanItem[i].style.color = "#2042AB";
        }
        if (spanItem[i].className == "text-red") {
          spanItem[i].style.color = "#D0021B";
        }
        if (spanItem[i].className == "text-gray") {
          spanItem[i].style.color = "#999999";
        }
      }
      let Page = newWin.document.body.getElementsByClassName("ivu-page")[0];
      Page.style.margin = "0";
      Page.style.textDecoration = "none";
      Page.style.listStyle = "none";
      Page.style.fontSize = "14px";
      let PageLi = Page.getElementsByTagName("li");
      for (let i = 0; i < PageLi.length; i++) {
        PageLi[i].style.display = "inline-block";
        PageLi[i].style.textDecoration = "none";
        PageLi[i].style.listStyle = "none";
      }
      newWin.print();
    },
    _getPage(page) {
      // 点击分页
      let vm = this;
      vm.page = page;
      vm.getListData();
    },
    getListData() {
      let vm = this;
      let params = {};
      params.order_id = vm.data.order_id;
      params.status = vm.curStatus;
      params.open_filter = vm.openFilter;
      params.type = vm.data.type;
      params.page = vm.page;
      params.row = vm.row;
      vm.getListFlag = false;
      vm.rechargeRecordDetailsSub(params);
    },
    rechargeRecordDetailsSub(params) {
      // 批量充值详情子列表
      let vm = this;
      vm.$post("/app/recharge/rechargeRecordDetailsSub", params, {
        loading: true
      }).then(res => {
        console.log("rechargeRecordDetailsSub", res);
        vm.getListFlag = true;
        vm.listData = res.list;
        vm.orderData = res;
        vm.getExportExcelData();
      });
    }
  },
  watch: {},
  deactivated() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.toExcel {
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  button {
    min-width: 70px;
    text-align: center;
    font-size: 14px;
  }
}
.list-wrap {
  margin-top: 20px;
  padding: 0 50px;
  .item-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    line-height: 1;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    h3 {
      font-size: 16px;
      font-weight: 500;
    }
    p {
      margin-top: 5px;
    }
    .list-l {
      flex: 1;
    }
    .list-r {
      text-align: right;
    }
  }
}

.page-wrap {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .total {
    flex: 1;
    line-height: 24px;
    display: flex;
    flex-flow: wrap;
    justify-content: flex-start;
    span {
      margin-right: 10px;
    }
  }
}
</style>
